import { LOCALE as t, ILLUSTRATION_OPTIMIZER as l, TRANSLATE_FUNCTION as o, ROUTER_LINK_COMPONENT as i } from "./plugin.js";
function T(e) {
  return {
    install(r) {
      r.provide(t, e.locale), r.provide(l, e.illustrationOptimizer), r.provide(o, e.translateFunction), r.provide(i, e.RouterLinkComponent);
    }
  };
}
export {
  T as createRevolvePlugin
};
